export function assertPrimitive(value: any, expectedType: 'string' | 'boolean' | 'number'): void {
  const actualType = typeof value
  if (actualType !== expectedType) throw new HyveTypeError(expectedType, actualType, value)
}

class HyveTypeError extends TypeError {
  constructor(expectedType: string, actualType: string, value: any) {
    super(`Expected value ${value} to be type of '${expectedType}' but found '${actualType}'`)
  }
}
